import React from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';
import { Account } from '../account/account';
import { Logout } from '../account/logout';
import { DynamicRemoteFederatedComponent } from '../app-dynamic-remote';
import { Analytics } from '../pages/analytics';
import { ProtectedRoute } from '../protected-route';
import { UserManagement } from '../user-management/UserManagement';
import { Dashboard } from '../pages/dashboard/Dashboard';
import { availableRoutes } from './available-routes';

function AuthorizedRoutes() {
  return (
    <Routes>
      {[availableRoutes.vehicles, availableRoutes.vehiclesDetails].map(
        (path) => (
          <Route
            key={path}
            path={path}
            element={
              <ProtectedRoute
                element={
                  <DynamicRemoteFederatedComponent exposedFrom="vehicles/App" />
                }
              />
            }
          />
        ),
      )}

      <Route
        path={availableRoutes.shipmentExecution}
        element={
          <ProtectedRoute
            element={
              <DynamicRemoteFederatedComponent
                exposedFrom="shipmentExecution/App"
                dependencies={['carrierManagement/AddDispatcherDialog']}
              />
            }
          />
        }
      />

      <Route
        path={availableRoutes.userManagement}
        element={<ProtectedRoute element={<UserManagement />} />}
      />

      <Route
        path={availableRoutes.dataExport}
        element={
          <ProtectedRoute
            element={
              <DynamicRemoteFederatedComponent exposedFrom="dataExport/App" />
            }
          />
        }
      />

      <Route
        path={availableRoutes.tourPlanner}
        element={
          <ProtectedRoute
            element={
              <DynamicRemoteFederatedComponent
                exposedFrom="tourPlanner/App"
                dependencies={[
                  'orderManagement/UpdateLoadDialog',
                  'orderManagement/DeleteLoadDialog',
                ]}
              />
            }
          />
        }
      />

      {[availableRoutes.locations, availableRoutes.locationDetails].map(
        (path) => (
          // eslint-disable-next-line
          <Route
            key={path}
            path={path}
            element={
              <ProtectedRoute
                element={
                  <DynamicRemoteFederatedComponent exposedFrom="locations/App" />
                }
              />
            }
          />
        ),
      )}

      <Route
        path={availableRoutes.dashboard}
        element={<ProtectedRoute element={<Dashboard />} />}
      />

      <Route
        path={availableRoutes.fleetManagement}
        element={
          <ProtectedRoute
            element={
              <DynamicRemoteFederatedComponent exposedFrom="carrierManagement/FleetManagementApp" />
            }
          />
        }
      />
      <Route
        path={availableRoutes.dispatchers}
        element={
          <ProtectedRoute
            element={
              <DynamicRemoteFederatedComponent exposedFrom="carrierManagement/DispatchersApp" />
            }
          />
        }
      />
      <Route
        path={availableRoutes.carrierNetwork}
        element={
          <ProtectedRoute
            element={
              <DynamicRemoteFederatedComponent exposedFrom="carrierManagement/CarrierNetworkApp" />
            }
          />
        }
      />
      <Route
        path={availableRoutes.rateManagement}
        element={
          <ProtectedRoute
            element={
              <DynamicRemoteFederatedComponent exposedFrom="carrierManagement/RateManagementApp" />
            }
          />
        }
      />
      <Route
        path={availableRoutes.orders}
        element={
          <ProtectedRoute
            element={
              <DynamicRemoteFederatedComponent exposedFrom="orderManagement/OrdersApp" />
            }
          />
        }
      />
      <Route
        path={availableRoutes.orderPlanning}
        element={
          <ProtectedRoute
            element={
              <DynamicRemoteFederatedComponent exposedFrom="orderPlanning/OrderPlanningApp" />
            }
          />
        }
      />
      <Route
        path={availableRoutes.packages}
        element={
          <ProtectedRoute
            element={
              <DynamicRemoteFederatedComponent exposedFrom="orderManagement/PackagesApp" />
            }
          />
        }
      />
      <Route
        path={availableRoutes.articles}
        element={
          <ProtectedRoute
            element={
              <DynamicRemoteFederatedComponent exposedFrom="orderManagement/ArticlesApp" />
            }
          />
        }
      />
      <Route
        path={availableRoutes.ordersLoads}
        element={
          <ProtectedRoute
            element={
              <DynamicRemoteFederatedComponent exposedFrom="orderManagement/LoadsApp" />
            }
          />
        }
      />
      <Route
        path={availableRoutes.ordersLocations}
        element={
          <ProtectedRoute
            element={
              <DynamicRemoteFederatedComponent exposedFrom="orderManagement/LocationsApp" />
            }
          />
        }
      />
      <Route
        path={availableRoutes.analytics}
        element={<ProtectedRoute element={<Analytics />} />}
      />
      <Route
        path={availableRoutes.profile}
        element={<ProtectedRoute element={<Account />} />}
      />
      <Route
        path={availableRoutes.logout}
        element={<ProtectedRoute element={<Logout />} />}
      />
      <Route
        path="*"
        element={<Navigate replace to={availableRoutes.dashboard} />}
      />
    </Routes>
  );
}

export default AuthorizedRoutes;
